import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";
import { Translation } from 'react-i18next';

import {connect} from "react-redux";
import { patchMobileAppsLink } from 'redux/links/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './MobileAppLinkUrl.css';

const ENTER_KEY = 13;


class MobileAppLinkUrl extends Component {
  static propTypes = {
    patchMobileAppsLink: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    location: PropTypes.object,
    linkId: PropTypes.number.isRequired,
    pacthMobileAppsLinkError: PropTypes.object,
    appType: PropTypes.string.isRequired,
  };

  static defaultProps = {
    location: null,
    pacthMobileAppsLinkError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.url) {
      this.setState({
        initialValue: this.props.url,
        currentValue: this.props.url,
      });
    }

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.setState({ currentValue: this.props.url });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeUrl = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('url', currentValue);
      this.props.patchMobileAppsLink(this.props.linkId, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeUrl();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeUrl();
  };

  executeValidation = () => {
    const { pacthMobileAppsLinkError } = this.props;
    const { currentValue } = this.state;

    if (pacthMobileAppsLinkError && pacthMobileAppsLinkError.url) {
      return pacthMobileAppsLinkError.url;
    }
    if (currentValue === '' ) {
      return i18n.t("App Url should not be empty");
    }
    return null;
  };

  render() {
    const { appType } = this.props;
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="mobile-app-link-url__component">
            <div className="input-wrapper">
              <InputField
                value={currentValue}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ currentValue: e.target.value });
                }}
                customRef={this.inputEditFieldRef}
                error={this.executeValidation() && {text: this.executeValidation()}}
              />
            </div>
            <div className="subtext">
              {appType === 'ios' ? 'iOS' : 'Android'} {t("App Link")}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    pacthMobileAppsLinkError: state.linksReducer.pacthMobileAppsLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchMobileAppsLink,
  },
)(onClickOutside(MobileAppLinkUrl));
